import React, { useEffect, useState } from "react";
import { FaPlus, FaFilter, FaTrash, FaEdit, FaBell } from "react-icons/fa";
import AppPagination from "../components/AppPagination";
import ReminderModal from "../components/Modals/ReminderModal";
import DeleteModal from "../components/Modals/DeleteModal";

const Reminder = () => {
  const [showReminderModal, setShowReminderModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [deleteId, setDeleteId] = useState(null);

  const [editData, setEditData] = useState(null);

  const [showFilter, setShowFilter] = useState(false);

  const [loading, setLoading] = useState(true);
    useEffect(() => {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }, []);
  

  // Reminder Data
  const reminderData = [
    {
      id: 1,
      title: "Client Meeting",
      date: "2026-05-18",
      time: "11:00 AM",
      priority: "High",
      status: "Pending",
    },

    {
      id: 2,
      title: "Project Followup",
      date: "2026-05-19",
      time: "02:00 PM",
      priority: "Medium",
      status: "Completed",
    },

    {
      id: 3,
      title: "Invoice Reminder",
      date: "2026-05-20",
      time: "05:30 PM",
      priority: "Low",
      status: "Pending",
    },

    {
      id: 4,
      title: "Team Call",
      date: "2026-05-22",
      time: "04:00 PM",
      priority: "High",
      status: "Cancelled",
    },
  ];

  // Pagination
  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 5;

  const indexOfLastItem = currentPage * itemsPerPage;

  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const currentItems = reminderData.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(reminderData.length / itemsPerPage);

  const handleDelete = () => {
    console.log(deleteId);

    setShowDeleteModal(false);
  };

  return (
    <div className="lead-page">
      {/* Header */}
      <div className="lead-header">
        <div>
          <h2 className="mb-1">Reminder</h2>
        </div>

        <button
          className="btn btn-primary"
          onClick={() => {
            setEditData(null);
            setShowReminderModal(true);
          }}
        >
          <FaPlus className="me-1" />
          Add Reminder
        </button>
      </div>

      {/* Table Card */}
      <div className="card mb-4 card-light">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5 className="card-title mb-0">All Reminders</h5>

          <div className="d-flex gap-2 align-items-center">
            {showFilter && (
              <input
                type="text"
                className="form-control"
                placeholder="Search Reminder"
              />
            )}

            <button
              className="btn btn-dark"
              onClick={() => setShowFilter(!showFilter)}
            >
              <FaFilter className="me-1" />
              Filter
            </button>
          </div>
        </div>

        <div className="card-body">
          <div className="table-outer border">
          <div className="table-responsive">
            <table className="table m-0 align-middle">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Reminder</th>
                  <th>Date</th>
                  <th>Time</th>
                  <th>Priority</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="7" className="text-center py-4">
                      Loading...
                    </td>
                  </tr>
                ) : currentItems.length > 0 ? (
                  currentItems.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>

                      <td>
                        <div className="d-flex align-items-center gap-2">
                          <div
                            className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
                            style={{
                              width: "30px",
                              height: "30px",
                            }}
                          >
                            <FaBell size={14} />
                          </div>

                          <span className="fw-semibold">{item.title}</span>
                        </div>
                      </td>

                      <td>{item.date}</td>

                      <td>{item.time}</td>

                      <td>
                        <span
                          className={`badge ${
                            item.priority === "High"
                              ? "border border-danger text-danger"
                              : item.priority === "Medium"
                                ? "border border-warning text-warning"
                                : "border border-info text-info"
                          }`}
                        >
                          {item.priority}
                        </span>
                      </td>

                      <td>
                        <span
                          className={`badge ${
                            item.status === "Pending"
                              ? "bg-warning"
                              : item.status === "Completed"
                                ? "bg-success"
                                : "bg-danger"
                          }`}
                        >
                          {item.status}
                        </span>
                      </td>

                      <td>
                        <div className="d-flex gap-2">
                          {/* Edit */}
                          <button
                            className="btn btn-sm btn-info custum_edit text-white"
                            onClick={() => {
                              setEditData(item);

                              setShowReminderModal(true);
                            }}
                          >
                            <FaEdit />
                          </button>

                          {/* Delete */}
                          <button
                            className="btn btn-sm btn-info custum_danger"
                            onClick={() => {
                              setDeleteId(item.id);
                              setShowDeleteModal(true);
                            }}
                          >
                            <FaTrash />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="7" className="text-center py-4">
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          </div>

          {/* Pagination */}
          <div className="row mt-2 p-2">
            <div className="col-md-12">
              <AppPagination
                currentPage={currentPage}
                totalPages={totalPages}
                totalItems={reminderData.length}
                itemsPerPage={itemsPerPage}
                onPageChange={setCurrentPage}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Modal */}
      <ReminderModal
        show={showReminderModal}
        setShow={setShowReminderModal}
        editData={editData}
      />

      <DeleteModal
        show={showDeleteModal}
        setShow={setShowDeleteModal}
        onConfirm={handleDelete}
        title="Delete Reminder?"
        message="Are you sure you want to delete this reminder?"
      />
    </div>
  );
};

export default Reminder;
